module.exports = __webpack_public_path__ + "static/img/radio-ticked.aaa70882.svg";